<!-- ./src/components/contact.vue -->
<template>
  <div class="container">
    <div class="card">
      <form id="app"> 

       <div v-if="!submitted">

         <div class="form-group"> 
           <div align=left class="margin-left">
              <p v-if="errors.length" class="text-info margin-top margin-bottom" >
                <b>Please correct the following error(s):</b>
                <ul>
                    <li v-for="error in errors">{{ error }}</li>
                </ul>  
              </P>
           </div>   
         </div>

        <div class="form-group">
          <div align=left class="margin-left ">
            <label for="email" class="text-info margin-top margin-bottom">Your email address</label>
          </div>  
          <div align=left class="margin-right">
            <input type="email" class="form-control margin-left margin-right" id="getUserName" v-model='getUserName' placeholder="name@example.com">
          </div> <!--v-model='getUserName'-->
        </div>

        <div class="form-group">
          <div align=left class="margin-left">
            <label for="name" class="text-info margin-top margin-bottom" >Your name</label>
          </div>
          <div align=left class="margin-right">
            <input type="text" class="form-control margin-left margin-right" id="name" v-model='name' placeholder="">
          </div>
        </div>

        <div class="form-group">
          <div align=left class="margin-left">
            <label for="cartItemDescr" class="text-info margin-top margin-bottom">Order Request</label>
          </div>  
          <div align=left class="margin-right">
            <textarea class="form-control margin-left margin-right" id="cartItemDescr" v-model='cartItemDescr' rows="10">
            </textarea>
          </div>
        </div>

        <div class="form-group">
          <div align=left class="margin-left">
            <label for="addr" class="text-info margin-top margin-bottom">Shipping Address</label>
          </div>  
          <div align=left class="margin-right">
            <textarea class="form-control margin-left margin-right" id="addr" v-model='addr' rows="5"></textarea>
          </div>
        </div>
        
        <!--<button @click="checkForm" class="btn btn-default margin-bottom">Submit</button>-->
        <div class="form-group">
          &nbsp&nbsp&nbsp<a type="submit" href="#" v-on:click.stop.prevent="checkForm" class="btn btn-primary margin-bottom">Submit</a>
          &nbsp&nbsp&nbsp 
          <label for="msg" class="text-info margin-top margin-bottom">Note: We will contact you by email after receive your order. Thanks.</label>
        </div>

      </div> <!--Summitted-->
      <!--<div v-else class="alert alert-success" role="alert">-->
      <div v-else class="text-success" role="alert">
        <h5>Thank you</h5>
        <p>Your request has be sent!</p>
      </div>
      
      
      </form>
    </div>
  </div>
  <!-- /container --> 
   
</template>

<!-- ./src/components/contact.vue -->
<script>
import {
  mapActions,
  mapGetters
} from 'vuex';

export default {
  name: 'contact',
  data () {
    return {
      orderItems:'',
      errors: [],
      name: null,
      email: null,
      submitted: false
    }
  },
  computed: {
    ...mapGetters(['cartItemList','cartItemDescr','isUserLoggedIn','getUserName']),
     cartTotal() {
       //alert(this.$store.getters.cartTotal)
       return this.$store.getters.cartTotal;
     }
  },
  created() { //For Email.send
    let ckeditor = document.createElement('script');    
    ckeditor.setAttribute('src',"https://smtpjs.com/v2/smtp.js");
    document.head.appendChild(ckeditor);
  },
  methods:{
      checkForm: function (e) {
          this.errors = [];
          if (!this.name) {
             this.errors.push("Name required."); 
          }
          if(document.getElementById("getUserName").value){
            //due to 2 ways binding, need set to state.
            this.$store.commit('setUserName', document.getElementById("getUserName").value)
          }
          if (document.getElementById("cartItemDescr").value){
            this.$store.commit('setCartItemDescr',document.getElementById("cartItemDescr").value)
          }
          if (!this.getUserName) {
            this.errors.push('Email required.');
          } else if (!this.validEmail(this.getUserName)) {
            this.errors.push('Valid email required.');
          } else if (!this.cartItemDescr) {
            this.errors.push('Please input your order request.');
          } else if (!this.addr) {
            this.errors.push('Please input your shipping address.');
          }

          if (!this.errors.length) {
            Email.send("admin@wewamart.com",
                          "tsumtsum797@gmail.com",
                          "From " + this.name + " Email: " + this.getUserName,
                          "Order: " + this.cartItemDescr + "(Shipping address: " + this.addr + " )",
                          "smtp.gmail.com",
                          "ultraman2700@gmail.com",
                          "unhhrbmbdzmrbnox");
            //alert("Your message has be sent!");
            this.submitted = true;
            //return true;
          }
          e.preventDefault();
        },

      validEmail: function (email) {
          var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return re.test(email);
      }      
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.container {
    max-width: 50.9em;
}
.form-control{
    max-width: 46.9em;
}
.margin-left{
    margin-left: 10px;
}
.margin-top{
    margin-top: 3px;
}
.margin-bottom{
    margin-bottom: 3px;
}
.margin-right{
    margin-right: 80px;
}

</style>




// WEBPACK FOOTER //
// src/components/contact.vue